import React from 'react';
import SiteChrome from './SiteChrome';

const AffiliateAbout = () => {
  return (
    <SiteChrome>
      <section className="px-4 sm:px-6 py-10 sm:py-12">
        <div className="max-w-5xl mx-auto space-y-6">
          <div className="bg-white border border-gray-100 rounded-3xl p-5 sm:p-8 shadow-sm">
            <p className="text-xs uppercase tracking-[0.32em] text-primary-700 font-semibold mb-3">About Better Me</p>
            <h1 className="text-xl sm:text-2xl font-bold text-gray-900 leading-tight mb-4">
              A private space to reflect, notice patterns, and plan your life more clearly
            </h1>
            <p className="text-sm sm:text-base text-gray-700 leading-6 sm:leading-7 mb-3">
              Better Me is a self-reflection app built around journaling, habit tracking, decision review, spending awareness, and practical planning.
              It helps users capture what happened, notice recurring patterns, and make better day-to-day adjustments over time.
            </p>
            <p className="text-sm sm:text-base text-gray-700 leading-6 sm:leading-7">
              The app includes AI-powered reflection features that can respond to entries, surface themes, and help users think through routines,
              priorities, and behavior patterns in a more structured way.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-5">
            <div className="bg-white border border-gray-100 rounded-3xl p-5 shadow-sm">
              <h2 className="text-base font-bold text-gray-900 mb-3">What users use it for</h2>
              <ul className="space-y-2 text-sm text-gray-700 leading-6">
                <li>Daily journaling and reflection</li>
                <li>Tracking habits and consistency</li>
                <li>Reviewing spending patterns and triggers</li>
                <li>Thinking through decisions with more clarity</li>
                <li>Planning days, weeks, and personal priorities</li>
              </ul>
            </div>

            <div className="bg-white border border-gray-100 rounded-3xl p-5 shadow-sm">
              <h2 className="text-base font-bold text-gray-900 mb-3">How to describe it well</h2>
              <p className="text-sm text-gray-700 leading-6">
                Position Better Me as a journaling, habit, reflection, and planning tool. Strong conversion language usually comes from showing how it helps users understand their own routines and choices more clearly.
              </p>
            </div>

            <div className="bg-amber-50 border border-amber-200 rounded-3xl p-5 shadow-sm">
              <h2 className="text-base font-bold text-amber-950 mb-3">Compliance note</h2>
              <p className="text-sm text-amber-900 leading-6">
                Do not market Better Me as therapy, diagnosis, treatment, crisis support, or regulated legal or financial advice. Keep messaging focused on reflection, routines, self-awareness, and planning.
              </p>
            </div>
          </div>

          <div className="bg-slate-950 text-white rounded-3xl p-5 sm:p-6">
            <h2 className="text-base sm:text-lg font-bold mb-3">Conversion-safe positioning</h2>
            <div className="space-y-3 text-sm text-slate-200 leading-6">
              <p>
                Better Me works best for people who already care about growth but need a simple way to reflect consistently, notice patterns, and follow through better.
              </p>
              <p>
                Strong affiliate messaging usually sounds like this: a diary that talks back, a place to understand your patterns, or a practical tool for habits, spending awareness, and clearer planning.
              </p>
            </div>
          </div>
        </div>
      </section>
    </SiteChrome>
  );
};

export default AffiliateAbout;
